export const DEFAULT_TIME_PICKER_MINUTE_STEP = 5
export const DEFAULT_TIME_PICKER_OPEN_TIME = '12:00'
export const TIME_PICKER_HOURS = Array.from({length: 24}, (_, hour) => hour)
export const TIME_STRING_PATTERN = /^\d{2}:\d{2}$/
